module.exports = __webpack_public_path__ + "img/9788983923646.bdbc3534.jpg";